import { Category } from "../../others/accomodation.interfaces";
import Img from "../Img"

interface props extends Category {
    categoryName: string;
    skeleton?: string;
    className?: string;
    onClick: Function,
    isCurrent: boolean;
    _key: string;
}

const ServiceCategory = ({ categoryName, skeleton, className, thumbnail, isCurrent, _key }: props): JSX.Element => {
    if (skeleton) return <ServiceCategorySkeleton className={className} />
    return (
        <div className={`cursor-pointer relative h-24 w-44 ${isCurrent ? '' : 'opacity-50'} hover:opacity-100 shrink-0 snap-start`}>
            <Img
                src={thumbnail + '?random=' + _key}
                alt={`category-${categoryName}`}
                className={`rounded-xl h-20 w-44 brightness-75`}
            />
            <span className="absolute bottom-6 left-3 text-white font-bold">{categoryName}</span>
        </div>
    )
};

export default ServiceCategory;

export const ServiceCategorySkeleton = ({ className }: Partial<props>): JSX.Element => {
    return <div className={`h-24 w-44 rounded-xl bg-slate-400 animate-pulse max-w-[200px] ${className}`}></div>
};